import { ReactNode } from 'react';
import { Box, Container, Stack } from '@mui/material';
import HeroIntroPublic from '@/app/features/shared/intros/hero/ui/public/HeroIntro.public';

export function ShopRootFrame({ children }: { children: ReactNode }) {
    return <Stack component="main" spacing={0}>{children}</Stack>;
}

export function ShopHeroFrame({ content, background }: { content: ReactNode; background: ReactNode }) {
    return (
        <HeroIntroPublic
            baseHeight="90vh"
            content={(
                <Box
                    sx={{
                        '& .MuiTypography-colorPrimary': {
                            color: 'text.primary',
                        },
                    }}
                >
                    {content}
                </Box>
            )}
            background={background}
        />
    );
}

export function ShopProductsFrame({ children }: { children: ReactNode }) {
    return (
        <Container maxWidth="xl" component="div" sx={{ py: { xs: 4, md: 8 } }}>
            {children}
        </Container>
    );
}

export function ShopHeroBackgroundFrame({ children }: { children: ReactNode }) {
    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
            {children}
        </Box>
    );
}
